var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.38,50.65A5.86,5.86,0,0,0,54.52,48l-13.63,6.7a5.83,5.83,0,0,0-5.65-7.38H9.72a1,1,0,0,0-.71.29l-7,7H0v2H2.43a1,1,0,0,0,.71-.29l7-7h25.1a3.86,3.86,0,0,1,0,7.72h-17a1,1,0,1,0,0,2h17a5.84,5.84,0,0,0,2.47-.55h0l17.7-8.7a3.86,3.86,0,1,1,3.45,6.9L36.36,68H0v2H36.59a1,1,0,0,0,.45-.11L59.76,58.5a5.85,5.85,0,0,0,2.62-7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62,0H14a1,1,0,0,0,0,2H61V28H59V5a1,1,0,0,0-1-1H10A1,1,0,0,0,9,5V8H6A1,1,0,0,0,5,9V37a1,1,0,0,0,1,1H54a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1H11V6H57V33a1,1,0,0,0,2,0V30h3a1,1,0,0,0,1-1V1A1,1,0,0,0,62,0ZM12.92,10A7,7,0,0,1,7,15.92V10Zm2,0H45.06A9,9,0,0,0,53,17.94V28.06A9,9,0,0,0,45.06,36H14.94A9,9,0,0,0,7,28.06V17.94A9,9,0,0,0,14.94,10ZM7,30.08A7,7,0,0,1,12.92,36H7ZM47.08,36A7,7,0,0,1,53,30.08V36ZM53,15.92A7,7,0,0,1,47.08,10H53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,31a8,8,0,1,0-8-8A8,8,0,0,0,30,31Zm0-14a6,6,0,1,1-6,6A6,6,0,0,1,30,17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIco);
export default __webpack_public_path__ + "static/media/money-ico.29acdfe1533c169ab5980d7b182cca6f.svg";
export { ForwardRef as ReactComponent };